// actionType

// Get Company To User List
export const GET_COMPANY_TO_USER_LIST = "GET_COMPANY_TO_USER_LIST";
export const GET_COMPANY_TO_USER_LIST_SUCCESS =
  "GET_COMPANY_TO_USER_LIST_SUCCESS";
export const GET_COMPANY_TO_USER_LIST_FAILURE =
  "GET_COMPANY_TO_USER_LIST_FAILURE";

// Switch Company get request
export const SWITCH_COMPANY = "SWITCH_COMPANY";
export const SWITCH_COMPANY_SUCCESS = "SWITCH_COMPANY_SUCCESS";
export const SWITCH_COMPANY_FAILURE = "SWITCH_COMPANY_FAILURE";

// Get_Company_user_invitations
export const GET_COMPANY_USER_INVITATIONS = "GET_COMPANY_USER_INVITATIONS";
export const GET_COMPANY_USER_INVITATIONS_SUCCESS =
  "GET_COMPANY_USER_INVITATIONS_SUCCESS";
export const GET_COMPANY_USER_INVITATIONS_FAILURE =
  "GET_COMPANY_USER_INVITATIONS_FAILURE";

// Send Email Invitation to user
export const SEND_EMAIL_INVITATION = "SEND_EMAIL_INVITATION";
export const SEND_EMAIL_INVITATION_SUCCESS = "SEND_EMAIL_INVITATION_SUCCESS";
export const SEND_EMAIL_INVITATION_FAILURE = "SEND_EMAIL_INVITATION_FAILURE";

// Get Join Company Invitation List
export const GET_JOIN_COMPANY_INVITATION_LIST =
  "GET_JOIN_COMPANY_INVITATION_LIST";
export const GET_JOIN_COMPANY_INVITATION_LIST_SUCCESS =
  "GET_JOIN_COMPANY_INVITATION_LIST_SUCCESS";
export const GET_JOIN_COMPANY_INVITATION_LIST_FAILURE =
  "GET_JOIN_COMPANY_INVITATION_LIST_FAILURE";

// Accept Or Decline Invitation to join a company
export const ACCEPT_OR_DECLINE_INVITATION_TO_JOIN_COMPANY =
  "ACCEPT_OR_DECLINE_INVITATION_TO_JOIN_COMPANY";
export const ACCEPT_OR_DECLINE_INVITATION_TO_JOIN_COMPANY_SUCCESS =
  "ACCEPT_OR_DECLINE_INVITATION_TO_JOIN_COMPANY_SUCCESS";
export const ACCEPT_OR_DECLINE_INVITATION_TO_JOIN_COMPANY_FAILURE =
  "ACCEPT_OR_DECLINE_INVITATION_TO_JOIN_COMPANY_FAILURE";

// get Company Team Members List
export const GET_COMPANY_TEAM_MEMBERS_LIST = "GET_COMPANY_TEAM_MEMBERS_LIST";
export const GET_COMPANY_TEAM_MEMBERS_LIST_SUCCESS =
  "GET_COMPANY_TEAM_MEMBERS_LIST_SUCCESS";
export const GET_COMPANY_TEAM_MEMBERS_LIST_FAILURE =
  "GET_COMPANY_TEAM_MEMBERS_LIST_FAILURE";

// Get Company Details
export const GET_COMPANY_DETAILS = "GET_COMPANY_DETAILS";
export const GET_COMPANY_DETAILS_SUCCESS = "GET_COMPANY_DETAILS_SUCCESS";
export const GET_COMPANY_DETAILS_FAILURE = "GET_COMPANY_DETAILS_FAILURE";

//Update Company Details
export const UPDATE_COMPANY_DETAILS = "UPDATE_COMPANY_DETAILS";
export const UPDATE_COMPANY_DETAILS_SUCCESS = "UPDATE_COMPANY_DETAILS_SUCCESS";
export const UPDATE_COMPANY_DETAILS_FAILURE = "UPDATE_COMPANY_DETAILS_FAILURE";

// User Available Menu
export const GET_USER_AVAILABLE_MENU = "GET_USER_AVAILABLE_MENU";
export const GET_USER_AVAILABLE_MENU_SUCCESS =
  "GET_USER_AVAILABLE_MENU_SUCCESS";
export const GET_USER_AVAILABLE_MENU_FAILURE =
  "GET_USER_AVAILABLE_MENU_FAILURE";

// user available dashboard
export const GET_USER_AVAILABLE_DASHBOARD = "GET_USER_AVAILABLE_DASHBOARD";
export const GET_USER_AVAILABLE_DASHBOARD_SUCCESS =
  "GET_USER_AVAILABLE_DASHBOARD_SUCCESS";
export const GET_USER_AVAILABLE_DASHBOARD_FAILURE =
  "GET_USER_AVAILABLE_DASHBOARD_FAILURE";

// map user dashboard and menu to user
export const MAP_DASHBOARD_AND_MENU_TO_USER = "MAP_DASHBOARD_AND_MENU_TO_USER";
export const MAP_DASHBOARD_AND_MENU_TO_USER_SUCCESS =
  "MAP_DASHBOARD_AND_MENU_TO_USER_SUCCESS";
export const MAP_DASHBOARD_AND_MENU_TO_USER_FAILURE =
  "MAP_DASHBOARD_AND_MENU_TO_USER_FAILURE";

///companytouser/list/team
export const GET_COMPANY_TO_USER_LIST_TEAM = "GET_COMPANY_TO_USER_LIST_TEAM";
export const GET_COMPANY_TO_USER_LIST_TEAM_SUCCESS =
  "GET_COMPANY_TO_USER_LIST_TEAM_SUCCESS";
export const GET_COMPANY_TO_USER_LIST_TEAM_FAILURE =
  "GET_COMPANY_TO_USER_LIST_TEAM_FAILURE";

///companytouser/create
export const CREATE_COMPANY_TO_USER = "CREATE_COMPANY_TO_USER";
export const CREATE_COMPANY_TO_USER_SUCCESS = "CREATE_COMPANY_TO_USER_SUCCESS";
export const CREATE_COMPANY_TO_USER_FAILURE = "CREATE_COMPANY_TO_USER_FAILURE";

///companytouser/update/team
export const UPDATE_COMPANY_TO_USER_TEAM = "UPDATE_COMPANY_TO_USER_TEAM";
export const UPDATE_COMPANY_TO_USER_TEAM_SUCCESS =
  "UPDATE_COMPANY_TO_USER_TEAM_SUCCESS";
export const UPDATE_COMPANY_TO_USER_TEAM_FAILURE =
  "UPDATE_COMPANY_TO_USER_TEAM_FAILURE";

///companytouser/delete
export const DELETE_COMPANY_TO_USER = "DELETE_COMPANY_TO_USER";
export const DELETE_COMPANY_TO_USER_SUCCESS = "DELETE_COMPANY_TO_USER_SUCCESS";
export const DELETE_COMPANY_TO_USER_FAILURE = "DELETE_COMPANY_TO_USER_FAILURE";

///companytouser/lockuser
export const COMPANY_TO_USER_LOCK_USER = "COMPANY_TO_USER_LOCK_USER";
export const COMPANY_TO_USER_LOCK_USER_SUCCESS =
  "COMPANY_TO_USER_LOCK_USER_SUCCESS";
export const COMPANY_TO_USER_LOCK_USER_FAILURE =
  "COMPANY_TO_USER_LOCK_USER_FAILURE";

///companytouser/unlockuser
export const COMPANY_TO_USER_UNLOCK_USER = "COMPANY_TO_USER_UNLOCK_USER";
export const COMPANY_TO_USER_UNLOCK_USER_SUCCESS =
  "COMPANY_TO_USER_UNLOCK_USER_SUCCESS";
export const COMPANY_TO_USER_UNLOCK_USER_FAILURE =
  "COMPANY_TO_USER_UNLOCK_USER_FAILURE";

///companytouser/resetpassword
export const COMPANY_TO_USER_RESET_PASSWORD = "COMPANY_TO_USER_RESET_PASSWORD";
export const COMPANY_TO_USER_RESET_PASSWORD_SUCCESS =
  "COMPANY_TO_USER_RESET_PASSWORD_SUCCESS";
export const COMPANY_TO_USER_RESET_PASSWORD_FAILURE =
  "COMPANY_TO_USER_RESET_PASSWORD_FAILURE";

///subscriptionlicence/update/user
export const COMPANY_TO_USER_UPDATE_SUBSCRIPTION_LICENCE_AND_SECURITY =
  "COMPANY_TO_USER_UPDATE_SUBSCRIPTION_LICENCE_AND_SECURITY";
export const COMPANY_TO_USER_UPDATE_SUBSCRIPTION_LICENCE_AND_SECURITY_SUCCESS =
  "COMPANY_TO_USER_UPDATE_SUBSCRIPTION_LICENCE_AND_SECURITY_SUCCESS";
export const COMPANY_TO_USER_UPDATE_SUBSCRIPTION_LICENCE_AND_SECURITY_FAILURE =
  "COMPANY_TO_USER_UPDATE_SUBSCRIPTION_LICENCE_AND_SECURITY_FAILURE";

///companytouser/data/
export const GET_COMPANY_TO_USER_DATA = "GET_COMPANY_TO_USER_DATA";
export const GET_COMPANY_TO_USER_DATA_SUCCESS =
  "GET_COMPANY_TO_USER_DATA_SUCCESS";
export const GET_COMPANY_TO_USER_DATA_FAILURE =
  "GET_COMPANY_TO_USER_DATA_FAILURE";
